const Auth = {
  login: () => 'login',
  logout: () => 'logout',
  changePassword: () => 'store/change-password',
}
export default Auth
